import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from './styles.local.less';

export default class FiltersTitle extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { children } = this.props;

    return <h5 className={cn.root}>{children}</h5>;
  }
}
